"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
var common_1 = require("@opengsn/common");
// a JSON array of deployed GSN networks. read paymaster addresses.
// (yarn deploy also reads the forwarder address)
var gsn_networks_json_1 = __importDefault(require("./gsn-networks.json"));
// generated by "hardhat deploy" in this project
var ctf_networks_json_1 = __importDefault(require("./ctf-networks.json"));
var networksMetaInfo_1 = require("./networksMetaInfo");
function getLocalNetwork() {
    console.log('==reading localnet dir=', __dirname);
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var paymasterAddress = require('../../../../build/gsn/Paymaster.json').address;
        var paymaster = {
            address: paymasterAddress,
            name: 'Accept Everything Paymaster',
            paymasterType: common_1.PaymasterType.AcceptEverythingPaymaster,
            debugUseType: false
        };
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var ctf = require('../../../ctf-eth/deployments/development/CaptureTheFlag.json').address;
        return { paymaster: paymaster, ctf: ctf };
    }
    catch (e) {
        console.warn('No local network:', e.message);
    }
}
function getNetworksInfo(networks) {
    return networks.reduce(function (set, chainId) {
        var _a;
        var _b, _c;
        console.log('network.reduce', chainId);
        var ctf;
        var paymasters = [];
        if (chainId.match(/1337/) != null) {
            var localnet = getLocalNetwork();
            if (localnet == null) {
                // no local network..
                return set;
            }
            paymasters = [localnet.paymaster];
            ctf = localnet.ctf;
        }
        else {
            var entry = (_b = gsn_networks_json_1.default[chainId]) === null || _b === void 0 ? void 0 : _b[0].contracts.paymasters;
            for (var _i = 0, entry_1 = entry; _i < entry_1.length; _i++) {
                var paymasterInfo = entry_1[_i];
                paymasters.push(paymasterInfo);
            }
            if (paymasters.length === 0) {
                throw new Error("GSN (Paymaster) not deployed on ".concat(chainId));
            }
            ctf = (_c = ctf_networks_json_1.default[chainId][0].contracts) === null || _c === void 0 ? void 0 : _c.CaptureTheFlag.address;
            if (ctf == null) {
                throw new Error("CaptureTheFlag not deployed on ".concat(chainId));
            }
        }
        var metaItems = networksMetaInfo_1.networksMetaInfo[chainId];
        if (metaItems == null) {
            throw new Error("CTF deployed on ".concat(chainId, " but no networksMetaInfo"));
        }
        var name = metaItems.name, explorer = metaItems.explorer;
        var networkInfo = {
            name: name,
            explorer: explorer,
            ctf: ctf,
            paymasters: paymasters
        };
        return __assign((_a = {}, _a[chainId] = networkInfo, _a), set);
    }, {});
}
// build a list from the CTF deployments.
// make sure we have GSN deployed on that network, too.
var ctfNetworkIds = Object.keys(ctf_networks_json_1.default);
console.log('ctf networks=', ctfNetworkIds);
exports.networks = getNetworksInfo(__spreadArray(['31337', '1337'], ctfNetworkIds, true));
console.log('===exported networks=', exports.networks);
